module.exports = __webpack_public_path__ + "img/innovation.3ad16ff7.svg";